import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import Address from '../address/Address';
import { TicketCommercialLoanSecuritySplitType } from './TicketCommercialLoanSecuritySplit.enum';
import { OwnershipType } from '../global/OwnershipType.enum';
import { PropertyType } from '../global/PropertyType.enum';
import { ZoningOption } from '../global/ZoningOption.enum';
import type { ITicketCommercialLoanSecuritySplit } from './TicketCommercialLoanSecuritySplit.interface';

export default class TicketCommercialLoanSecuritySplit
  implements ITicketCommercialLoanSecuritySplit {
  id: string;
  address: Address;
  value: number;
  lender: string;
  typeDetails: string;
  securityType: TicketCommercialLoanSecuritySplitType;
  zoning: ZoningOption;
  propertyType: PropertyType;
  ownershipType: OwnershipType;

  static build = (data: ITicketCommercialLoanSecuritySplit) =>
    new TicketCommercialLoanSecuritySplit(data);

  static blank = (securityType) =>
    new TicketCommercialLoanSecuritySplit({ id: uuid(), securityType });

  /**
   * Constructor
   * @param {ITicketCommercialLoanSecuritySplit} data
   */
  constructor(data?: ITicketCommercialLoanSecuritySplit) {
    this.id = toUUID(data?.id) || uuid();
    this.address = new Address(data?.address);
    this.value = parseFloat(data?.value || 0);
    this.lender = data?.lender || '';
    this.typeDetails = data?.typeDetails || '';
    this.securityType = TicketCommercialLoanSecuritySplitType.of(data?.securityType?.id);
    this.zoning = ZoningOption.of(data?.zoning?.name || data?.zoning?.toString());
    this.propertyType = PropertyType.of(data?.propertyType?.name || `p${data?.propertyType}`);
    this.ownershipType = OwnershipType.of(
      data?.ownershipType?.name || data?.ownershipType?.toString()
    );
  }
}
